import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useImperativeHandle,
  useContext,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Alert,
  AppBar,
  Avatar,
  Box,
  Card,
  IconButton,
  Modal,
  Toolbar,
  Typography,
} from "@mui/material";
import Paper, { PaperProps } from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import TkButton from "../../../components/atoms/TkButton";
import TkDownloadLink from "../../../components/atoms/TkDownloadLink";
import authorityUserType from "../../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../../context/globalContext";
import { BusinessContext } from "../../../context/businessContext";
import { TkRouteContext } from "../../../context/tkRouteContext";
import { useConcatRoutes } from "../../../routes/router";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";
import _ from "lodash";
import "./_style.scss";

export const Chats = (props: any) => {
  const { chats, onChange } = props;
  const navigate = useNavigate();
  const loaction = useLocation();
  const { state } = useContext(GlobalContext);
  const { setState: setBusinessContextState } = useContext(BusinessContext);
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const [error, setError] = useState("");

  const saveSetRouter = useRef<any[]>([]);
  const setRouterSussess = useRef(true);

  type Answer = {
    nextId?: string;
    path?: string;
    url?: string;
  };

  useEffect(() => {
    const path = loaction.pathname;

    if (path === "/SCRC070008") return;
    if (saveSetRouter.current?.length === 0) return;

    const isSame = _.isEqual(routerState.routerList, saveSetRouter.current);

    if (setRouterSussess.current && isSame) return;

    setRouterState({
      routerList: saveSetRouter.current,
    });

    setRouterSussess.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerState.routerList, saveSetRouter.current]);

  const strategies: { [key: string]: (answer: Answer) => void } = {
    path: (answer) => {
      if (answer.path) {
        // 代行者の場合は画面遷移を行わない
        if (
          state.authInfo?.userType === authorityUserType.userTypeNumber.DAIKOSHA
        ) {
          setError("TKMSG_SCR0126E");
          return;
        }

        const businessMap = {
          SCRC040103: "JOB-07",
          SCRC050030: "",
          SCRC050101: "JOB-15",
          SCRC060033: "JOB-25",
          SCRC060103: "JOB-27",
          SCRC060112: "JOB-25",
          SCRC060118: "JOB-32",
          SCRC070007: "JOB-23",
          SCRC040002: "",
          SCRC040101: "",
          SCRC040106: "",
          SCRC050017: "",
          SCRC050019: "",
          SCRC050120: "JOB-18",
          SCRC060116: "JOB-26",
          SCRC100001: "",
          SCRC100002: "",
        };

        let routerList = [
          {
            href: "/SCRC020001",
            title: "共済契約者ホーム",
          },
        ];

        const cleanedPath = answer.path.startsWith("/")
          ? answer.path.slice(1)
          : answer.path;

        // eslint-disable-next-line react-hooks/rules-of-hooks
        const routers = useConcatRoutes();

        const router = routers.find((r) => r.path === answer.path);
        const newItem = _.cloneDeep(router);

        routerList[1] = {
          title: newItem?.meta?.title as string,
          href: answer.path as string,
        };

        saveSetRouter.current = routerList;
        setRouterSussess.current = false;

        setBusinessContextState({
          common: {
            businessType:
              businessMap[cleanedPath as keyof typeof businessMap] ?? "",
          },
        });

        navigate(answer.path);
      }
    },
    url: (answer) => {
      if (answer.url) {
        window.open(answer.url, "_blank");
      }
    },
    default: (answer) => {
      onChange && onChange(answer);
    },
  };

  const handleClick = (answer: Answer) => {
    setError("");
    if (!answer.nextId) {
      if (answer.path) {
        strategies.path(answer);
        return;
      }

      if (answer.url) {
        strategies.url(answer);
        return;
      }
    }

    strategies.default(answer);
  };

  const messagesEndRef = useRef<HTMLElement>(null);
  const questionRefs = useRef<any>([]);

  useEffect(() => {
    if (questionRefs.current && questionRefs.current.length > 0) {
      questionRefs.current = questionRefs.current.filter(
        (ref: any) => ref !== null
      );
      questionRefs.current[questionRefs.current.length - 1]?.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [chats]);

  return (
    <Box ref={messagesEndRef} className="chat" data-testid="chat">
      {error && (
        <Box className="alert">
          <Alert severity="error">{TkPropertyMessageGet(error)}</Alert>
        </Box>
      )}
      {chats.map((i: any, k: any) => (
        <React.Fragment key={k}>
          <Box
            ref={(el) => (questionRefs.current[k] = el)}
            className={`${i.type}-box`}
          >
            {i.type === "question" ? (
              <Avatar className="avatarBot">AUTO</Avatar>
            ) : (
              <Avatar className="avatarKei">契</Avatar>
            )}

            <Card variant="outlined" className={`${i.type}-card`}>
              <Box className="card">
                <div
                  dangerouslySetInnerHTML={{
                    __html: i.question.replace(/\n/g, "<br />"),
                  }}
                ></div>
                {i.fileLists?.map((file: any, index: any) => {
                  return (
                    <TkDownloadLink
                      dataname={file[`fileName${index + 1}`]}
                      base64filedata={file[`file${index + 1}`]}
                      downloadBase64
                    ></TkDownloadLink>
                  );
                })}

                {i.answers?.map((item: any, index: any) => {
                  return (
                    <React.Fragment key={index}>
                      <Box>
                        <TkButton
                          className="button"
                          onClick={() => handleClick(item)}
                          disabled={
                            state.authInfo?.contractApprovalDate === null &&
                            item.path !== null
                          }
                        >
                          {item.content}
                        </TkButton>
                      </Box>
                    </React.Fragment>
                  );
                })}
              </Box>
            </Card>
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};

const DraggableComponent = React.forwardRef<
  HTMLDivElement,
  PaperProps & { children?: React.ReactNode; isOrigin: boolean }
>((props, ref) => {
  const { isOrigin, ...otherProps } = props;
  const [position, setPosition] = useState({
    x: window.innerWidth - 525,
    y: window.innerHeight - 400,
  });
  const [size, setSize] = useState({ width: 525, height: 400 });
  const draggableRef = useRef<HTMLDivElement>(null);
  const resizing = useRef(false);
  const dragging = useRef(false);
  const offset = useRef({ x: 0, y: 0 });
  const resizeOffset = useRef({ width: 0, height: 0 });

  useImperativeHandle(ref, () => draggableRef.current!);

  const handleMouseMove = useCallback(
    (event: MouseEvent) => {
      if (!draggableRef.current) return;

      if (dragging.current) {
        const newX = event.clientX - offset.current.x;
        const newY = event.clientY - offset.current.y;

        const maxX = window.innerWidth - size.width;
        const maxY = isOrigin
          ? window.innerHeight - size.height
          : window.innerHeight - 53;

        const clampedX = Math.max(0, Math.min(newX, maxX));
        const clampedY = Math.max(0, Math.min(newY, maxY));

        setPosition({ x: clampedX, y: clampedY });
      } else if (resizing.current && isOrigin) {
        const minWidth = 400;
        const minHeight = 400;
        const maxWidth = Math.min(1000, window.innerWidth - position.x);
        const maxHeight = Math.min(800, window.innerHeight - position.y);

        const newWidth = Math.max(
          minWidth,
          Math.min(
            maxWidth,
            event.clientX -
              draggableRef.current.getBoundingClientRect().left +
              resizeOffset.current.width
          )
        );
        const newHeight = Math.max(
          minHeight,
          Math.min(
            maxHeight,
            event.clientY -
              draggableRef.current.getBoundingClientRect().top +
              resizeOffset.current.height
          )
        );

        setSize({ width: newWidth, height: newHeight });
      }
    },
    [position, size, isOrigin]
  );

  useEffect(() => {
    const handleResize = () => {
      const maxX = window.innerWidth - size.width;
      const maxY = isOrigin
        ? window.innerHeight - size.height
        : window.innerHeight - 53;
      setPosition((prevPosition) => ({
        x: Math.min(Math.max(prevPosition.x, 0), maxX),
        y: Math.min(Math.max(prevPosition.y, 0), maxY),
      }));

      const adjustedWidth = Math.min(
        size.width,
        window.innerWidth - position.x - 30
      );
      const adjustedHeight = Math.min(
        size.height,
        window.innerHeight - position.y
      );
      setSize({
        width: Math.max(400, adjustedWidth),
        height: Math.max(400, adjustedHeight),
      });
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleMouseMove, size, isOrigin]);

  const handleMouseDown = (event: React.MouseEvent) => {
    if (
      draggableRef.current &&
      event.clientY - draggableRef.current.getBoundingClientRect().top < 48
    ) {
      event.preventDefault();
      dragging.current = true;
      draggableRef.current.style.cursor = "grabbing";
      offset.current = {
        x: event.clientX - position.x,
        y: event.clientY - position.y,
      };
    }
  };

  const handleMouseUp = () => {
    if (dragging.current) {
      dragging.current = false;
      if (draggableRef.current) {
        draggableRef.current.style.cursor = "grab";
      }
    }
    if (resizing.current) {
      resizing.current = false;
      if (draggableRef.current) {
        draggableRef.current.style.cursor = "grab";
      }
    }
  };

  const handleResizeMouseDown = (event: React.MouseEvent) => {
    if (draggableRef.current) {
      event.preventDefault();
      resizing.current = true;
      draggableRef.current.style.cursor = "nwse-resize";
      resizeOffset.current = {
        width:
          size.width -
          (event.clientX - draggableRef.current.getBoundingClientRect().left),
        height:
          size.height -
          (event.clientY - draggableRef.current.getBoundingClientRect().top),
      };
    }
  };

  return (
    <Paper
      ref={draggableRef}
      {...otherProps}
      onMouseDown={handleMouseDown}
      style={{
        position: "absolute",
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: `${size.width}px`,
        height: `${size.height}px`,
        maxHeight: `800px`,
        maxWidth: `1000px`,
        minHeight: "400px",
        minWidth: "400px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        borderRadius: "8px",
        cursor: "auto",
      }}
    >
      {props.children}
      <Box
        onMouseDown={handleResizeMouseDown}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "20px",
          height: "20px",
          background:
            "linear-gradient(to bottom right, transparent 50%, #59c1bd 50%)",
          cursor: "nwse-resize",
        }}
      />
    </Paper>
  );
});

export const ChatDialog = (props: any) => {
  const { open = false, content, onClose } = props;
  const [isOrigin, setIsOrigin] = useState(true);

  return (
    <Modal
      className={`SCRC090001Modal ${!isOrigin ? "SCRC090001ModalClose" : ""}`}
      open={open}
      hideBackdrop
      disableScrollLock={true}
      component={DraggableComponent}
      isOrigin={isOrigin}
      aria-labelledby="draggable-modal-title"
      sx={{
        top: "inherit",
        left: "inherit",
      }}
      data-testid="chatDialog"
    >
      <>
        <AppBar position="static" id="draggable-modal-title" className="appbar">
          <Toolbar variant="dense" className="toolbar">
            <Typography>チャットQ&A</Typography>
            <Box className="headerButton">
              <IconButton
                aria-label="cropLandscape"
                size="small"
                onClick={() => setIsOrigin(!isOrigin)}
              >
                {isOrigin ? <RemoveIcon /> : <CropSquareIcon />}
              </IconButton>
              <IconButton aria-label="delete" size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        {isOrigin ? content : null}
      </>
    </Modal>
  );
};
